



















import { Component } from 'vue-property-decorator';

import { mixins } from 'vue-class-component';

import Container from '@/components/layout/Container.vue';
import LocaleSelectSolo from '@/components/common/LocaleSelectSolo.vue';
import InstallPrompt from '@/components/common/InstallPrompt.vue';
import FlatButton from '@/components/common/FlatButton.vue';

import InstallMixin from '@/mixins/install';

@Component({
  components: { InstallPrompt, LocaleSelectSolo, FlatButton, Container },
})
export default class HeaderNav extends mixins(InstallMixin) {
  get isPWA() {
    return window.matchMedia('(display-mode: standalone)').matches;
  }

  get logoRoute() {
    if (this.isPWA) {
      return { name: 'homescapesLandingPage' };
    }
    return { name: 'main' };
  }

  handleInstall() {
    this.promptInstall();
  }
}
